import { SdkPersistConfig } from "@payping/redux";
import localForage from "localforage";

const storeVersion = 3;

const whitelist = ["auth", "user", "settings", "loginRedirect", "dashboardPreference"];

const persistConfig: SdkPersistConfig = {
  storage: localForage,
  version: storeVersion,
  whitelist,
};

export default { ...persistConfig };
